import { fromJS } from 'immutable';
import {
  CLEAR_FILTER,
  CLEAR_FILTERS,
  CHANGE_FILTER,
  SET_PREVIOUS_FILTERS,
  SET_FILTERS,
  FILTRATION_SUCCESS,
} from './constants';
import { CHANGE_SORTING } from '../sorting/constants';

const initialState = fromJS({
  awaitFiltration: false,
  hasResults: false,
  hasMore: false,
  isDone: false,
  searchProgress: 0,
});

export default function statusReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_FILTER:
    case CLEAR_FILTERS:
    case CHANGE_FILTER:
    case CHANGE_SORTING:
    case SET_PREVIOUS_FILTERS:
    case SET_FILTERS:
      return state.set('awaitFiltration', true);
    case FILTRATION_SUCCESS:
      return state.set('awaitFiltration', false);

    default:
      return state;
  }
}
